<template>
  <div class="edit-staff-page">
    <div class="edit-staff-page__header md-layout">
      <div class="md-layout-item">
        <div class="nav-link" @click="goToPreviousPage">
          <i class="fas fa-chevron-left"></i>
          <span>{{ $t("staff.account_detail") }}</span>
        </div>
      </div>
    </div>
    <div class="fixed-plugin change-pwd">
      <button-change-password
        @showChangePasswordModal="showChangePasswordModal()"
      >
      </button-change-password>
    </div>
    <change-password
      :name="changePasswordModal.name"
      :title="changePasswordModal.title"
      :uuid="uuid"
    ></change-password>
    <isis-fab :title="$t('staff.staff_note')">
      <template #dropdown-menu-content>
        <fixed-note-list
          :list="noteList"
          :update-note-func="updateStaffData"
        ></fixed-note-list>
      </template>
    </isis-fab>
    <staff-infos-form
      ref="infosForm"
      :staffData="staffData"
      @onSubmit="editStaff"
      :serverValidations="serverValidations"
      :isEditPage="true"
    ></staff-infos-form>
  </div>
</template>

<script>
import StaffInfosForm from "./StaffInfosForm";
import { service_paths } from "@/constants/Services";
import { hasHistory, convertObj, genErrMsgOj, Message } from "@/helpers/utils";
import FixedNoteList from "@/pages/FixedNoteList.vue";
import IsisFab from "@/components/Base/IsisFab";
import ChangePassword from "@/pages/ChangePassword";
import { mapState, mapGetters } from "vuex";
import Role from "@/constants/Role";
import omit from "lodash/omit";
import { Staff } from "@/constants/Permissions";
import { hasValidRole } from "@/helpers/role-helper";
import { getId } from "@/helpers/utils";
import { forbidden_router_name } from "@/routes/routes";
import ButtonChangePassword from "@/components/Base/ButtonChangePassword.vue";

export default {
  components: {
    ChangePassword,
    StaffInfosForm,
    FixedNoteList,
    IsisFab,
    ButtonChangePassword
  },
  name: "EditStaffPage",
  data() {
    return {
      staffData: null,
      serverValidations: {},
      uuid: null
    };
  },
  computed: {
    changePasswordModal() {
      return {
        name: "change-password",
        title: this.$t("common.change_password")
      };
    },
    ...mapState("user", ["info"]),
    ...mapGetters("user", ["role"]),
    verifyUser() {
      return (
        getId(this.info) === this.staffId ||
        hasValidRole(this.role, [Role.Admin, Role.Principal]) ||
        this.$can(Staff.actions.view, Staff.subject) ||
        this.$can(Staff.actions.edit, Staff.subject)
      );
    },
    staffId() {
      return this.$route.params.id;
    },
    noteList() {
      return this.staffData?.notes;
    }
  },
  methods: {
    mergeAssignedStudent(staffInfo) {
      let assigned_student_response = [];
      staffInfo.assigned_student_information.forEach(item => {
        assigned_student_response.push(item.uuid);
      });
      return assigned_student_response.concat(staffInfo.list_student_assign);
    },

    editStaff(staffInfo) {
      let { updateAvatar, ...staffData } = staffInfo;
      staffData.assigned_student_uuids = [
        ...this.mergeAssignedStudent(staffInfo)
      ];
      staffData = omit(staffData, "list_student_assign");
      const errMsg = this.$t("common.form_invalid");
      this.$axios
        .put(
          `${service_paths.staffs}/${this.staffId}`,
          staffData,
          true,
          {},
          errMsg
        )
        .then(() => {
          const message = updateAvatar
            ? this.$t("staff.edited_staff_avatar_successfully")
            : this.$t("common.edit_success");
          Message.success(message);
          this.getStaffData();
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    },

    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },

    updateStaffData(formData) {
      return this.$axios
        .put(`${service_paths.staffs}/${this.staffId}`, formData)
        .then(({ data }) => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    getStaffData() {
      this.$axios
        .get(`${service_paths.staffs}/${this.staffId}`)
        .then(response => {
          this.staffData = Object.assign(
            { listStudentAssign: [] },
            convertObj.snakeCaseToCamelCase(response.data)
          );
          this.$refs.infosForm.getInitAddress(this.staffData);
          this.uuid = this.staffData.uuid;
        });
    },

    showChangePasswordModal() {
      this.$modal.show(this.changePasswordModal.name);
    }
  },
  created() {
    this.getStaffData();
    if (!this.verifyUser) {
      this.$router.push({ name: forbidden_router_name });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-staff-page {
  &__header {
    margin-bottom: 30px;

    .nav-link {
      font-size: 1.5rem;
      color: #1b1f22;
      font-weight: 500;

      cursor: pointer;

      &:hover {
        color: lighten(#1b1f22, 20%);
      }

      span {
        display: inline-block;
        margin-left: 15px;
      }
    }
  }
}
</style>
